import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
//import { parse } from 'querystring';
import { of } from "rxjs";

@Component({
  selector: "app-modal-form",
  templateUrl: "./modal-form.component.html",
  styleUrls: ["./modal-form.component.scss"],
})
export class ModalFormComponent implements OnInit {
  @Input()
  title: string = "Agregar";

  @Input()
  txtBtnAdd: string = "Registrar";

  @Input()
  showModal: boolean = false;

  @Input()
  showUpdate: boolean = false;

  @Input()
  listInputs: any[] = [];

  @Input()
  dataExtra: any;

  @Output()
  update = new EventEmitter<any>();

  @Output()
  add = new EventEmitter<any>();

  @Output()
  addAcuerdo = new EventEmitter<any>();

  @Output()
  selProv = new EventEmitter<any>();

  @Output()
  selDist = new EventEmitter<any>();

  @Output()
  close = new EventEmitter<any>();

  montoAcuerdo: any = 0;
  montoMinAcuerdo: any = 0;
  montoRecomendarAcuerdo: any = 0;
  listaCuotasAcuerdo: any[] = [];
  errorMontoMinimo: string = "";

  constructor() {}

  ngOnInit() {
    if (this.dataExtra !== undefined) {
      //console.log(this.dataExtra)
    }
  }

  updateInfo(e: any) {
    this.update.emit();
  }

  addInfo(e: any) {
    this.add.emit();
    let nro_cuota: any = document.querySelector("#nro_cuotas");
    if (nro_cuota !== null) {
      this.simularData();
      this.add.emit(this.listaCuotasAcuerdo);
    }
    //this.simularData()
  }

  addAcuerdoPago(e: any) {
    this.addAcuerdo.emit();
  }

  closeModal() {
    this.close.emit();
  }

  selectProv(e: any) {
    this.selProv.emit(e);
  }

  selectDist(e: any) {
    this.selDist.emit(e);
  }

  calcular(e: any) {
    this.montoAcuerdo = 0;
    this.montoMinAcuerdo = 0;
    this.montoRecomendarAcuerdo = 0;

    for (let ctaI of this.dataExtra) {
      for (let cta of e.target) {
        if (cta.selected && cta.value == ctaI.cuenta) {
          this.montoAcuerdo =
            this.montoAcuerdo + ctaI.saldo_capital.$numberDecimal * 0.5;
          this.montoMinAcuerdo =
            this.montoMinAcuerdo + ctaI.saldo_capital.$numberDecimal * 0.35;
          this.montoRecomendarAcuerdo =
            this.montoRecomendarAcuerdo +
            ctaI.saldo_capital.$numberDecimal * 0.07;
        }
      }
    }

    this.montoAcuerdo = this.montoAcuerdo.toFixed(2);
    this.montoMinAcuerdo = this.montoMinAcuerdo.toFixed(2);
    this.montoRecomendarAcuerdo = this.montoRecomendarAcuerdo.toFixed(2);
    //console.log(this.montoAcuerdo.toFixed(2))
    //console.log(this.montoMinAcuerdo.toFixed(2))
    //console.log(this.montoRecomendarAcuerdo.toFixed(2))
  }

  validateCuotas() {
    let tipo_acuerdo: any = document.querySelector("#tipo_acuerdo");
    let nro_cuota: any = document.querySelector("#nro_cuotas");
    nro_cuota.removeAttribute("readonly");
    if (tipo_acuerdo.value == 1) {
      document
        .querySelector("#nro_cuotas")
        .setAttribute("readonly", "readonly");
      nro_cuota.value = 1;
      return false;
    }

    if (tipo_acuerdo.value == 2) {
      if (nro_cuota.value <= 1) {
        alert("El tipo de acuerdo: Armadas solo se maneja de 2 a 6 cuotas");
        nro_cuota.value = 2;
        return false;
      }

      if (nro_cuota.value > 6) {
        alert("El tipo de acuerdo: Armadas solo se maneja de 2 a 6 cuotas");
        nro_cuota.value = 2;
        return false;
      }
    }

    if (tipo_acuerdo.value == 3) {
      if (nro_cuota.value < 7) {
        alert(
          "El tipo de acuerdo: Fraccionamiento solo se maneja 7 a más cuotas"
        );
        nro_cuota.value = 7;
        return false;
      }
    }

    if (nro_cuota.value > 36) {
      alert("El acuerdo se puede fraccionar hasta 36 cuotas");
      nro_cuota.value = 36;
      return false;
    }

    this.simularData();
  }

  simulacionManual: boolean = false;

  simularData(cuotaEditada: any = "") {
    let nro_cuota: any = document.querySelector("#nro_cuotas");
    let monto_acuerdo: any = document.querySelector("#monto_acuerdo");
    let fecha_pago: any = document.querySelector("#fecha_pago");
    let monto_cuota_uno: any = document.querySelector("#monto_cuota_uno");
    let monto_c_uno =
      monto_cuota_uno.value == "" ? 0 : parseFloat(monto_cuota_uno.value);

    let monto_cuota: any =
      monto_cuota_uno.value != ""
        ? (monto_acuerdo.value - parseFloat(monto_cuota_uno.value)) /
          (nro_cuota.value - 1)
        : monto_acuerdo.value / nro_cuota.value;
    let fecha_: any = fecha_pago.value;
    let dataCuotas: any[] = [
      {
        cuota: 1,
        monto_cuota:
          monto_cuota_uno.value != ""
            ? monto_cuota_uno.value
            : monto_cuota.toFixed(2),
        fecha: fecha_pago.value,
        editado: false,
      },
    ];

    this.errorMontoMinimo = "";
    if (monto_acuerdo.value != "") {
      if (
        parseFloat(monto_acuerdo.value) <
        parseFloat(this.montoRecomendarAcuerdo)
      ) {
        this.errorMontoMinimo = `No es posible ingresar el acuerdo con dicho monto. El monto minimo es S/. ${this.montoMinAcuerdo} `; //, para un menor pero con una espera de validación es S/. ${this.montoRecomendarAcuerdo}
        this.listaCuotasAcuerdo = [];
        return false;
      }
      if (parseFloat(monto_acuerdo.value) < parseFloat(this.montoMinAcuerdo)) {
        this.errorMontoMinimo =
          "El monto del acuerdo es menor al minimo estipulado, ingresara como observado a la espera de validacion";
      }
    }

    let monto_total_acuerdo: any = 0;

    for (let i = 1; parseInt(nro_cuota.value) > i; ++i) {
      let base: any = 30 * i;

      try {
        fecha_ = this.getFecEntrega(base, fecha_pago.value);
      } catch (error) {
        console.log(error);
        break;
      }

      if (cuotaEditada != "") {
        if (cuotaEditada.cuota == i + 1) {
          dataCuotas.push({
            cuota: i + 1,
            monto_cuota: parseFloat(cuotaEditada.monto_cuota).toFixed(2),
            fecha: cuotaEditada.fecha,
            editado: true,
          });
          monto_total_acuerdo =
            parseFloat(monto_total_acuerdo) +
            parseFloat(cuotaEditada.monto_cuota);

          if (monto_c_uno != 0) {
            //-parseFloat(monto_cuota)
            monto_cuota =
              (parseFloat(monto_acuerdo.value) -
                monto_c_uno -
                parseFloat(monto_total_acuerdo)) /
              (parseInt(nro_cuota.value) - parseInt(cuotaEditada.cuota));
          } else {
            monto_cuota =
              (parseFloat(monto_acuerdo.value) -
                monto_c_uno -
                parseFloat(monto_total_acuerdo) -
                parseFloat(monto_cuota)) /
              (parseInt(nro_cuota.value) - parseInt(cuotaEditada.cuota));
          }
        } else {
          monto_total_acuerdo =
            parseFloat(monto_total_acuerdo) + parseFloat(monto_cuota);

          if (this.listaCuotasAcuerdo[i].editado == false) {
            dataCuotas.push({
              cuota: i + 1,
              monto_cuota: monto_cuota.toFixed(2),
              fecha: this.listaCuotasAcuerdo[i].fecha,
              editado: this.listaCuotasAcuerdo[i].editado,
            });

            //monto_cuota=(parseFloat(monto_acuerdo.value)-parseFloat(monto_total_acuerdo)-parseFloat(monto_cuota))/(parseInt(nro_cuota.value)-(i+1))
          } else {
            let montoCuotaManual: any = document.querySelector(
              `#monto-cuota-${i + 1}`
            );
            monto_cuota = parseFloat(montoCuotaManual.value);

            dataCuotas.push({
              cuota: i + 1,
              monto_cuota: monto_cuota.toFixed(2),
              fecha: this.listaCuotasAcuerdo[i].fecha,
              editado: this.listaCuotasAcuerdo[i].editado,
            });

            // monto_cuota=(parseFloat(monto_acuerdo.value)-parseFloat(monto_total_acuerdo)-parseFloat(monto_cuota))/(parseInt(nro_cuota.value)-(i+1))

            //console.log("monto_cuota",monto_cuota)
          }
        }
      } else if (this.simulacionManual == true) {
        monto_total_acuerdo =
          parseFloat(monto_total_acuerdo) + parseFloat(monto_cuota);
        dataCuotas.push({
          cuota: i + 1,
          monto_cuota: this.listaCuotasAcuerdo[i].monto_cuota,
          fecha: this.listaCuotasAcuerdo[i].fecha,
          editado: this.listaCuotasAcuerdo[i].editado,
        });
      } else {
        dataCuotas.push({
          cuota: i + 1,
          monto_cuota: monto_cuota.toFixed(2),
          fecha: fecha_,
          editado: this.simulacionManual
            ? this.listaCuotasAcuerdo[i].editado
            : false,
        });
      }
    }
    this.listaCuotasAcuerdo = dataCuotas;
    //console.log(this.listaCuotasAcuerdo)
  }

  getFecEntrega = (dias: any, fecha_: any) => {
    //console.log(fecha_.substr(8,2))
    let hoy: Date = new Date();
    let fecha_pago: Date = new Date(fecha_ + " 01:00:00");

    let i: number = 0;
    while (i < parseInt(dias)) {
      // 7 días habiles
      fecha_pago.setTime(fecha_pago.getTime() + 24 * 60 * 60 * 1000); // añadimos 1 día
      //if (fecha_pago.getDay() != 6 && hoy.getDay() != 0)
      i++;
    }

    let fecha: any =
      fecha_pago.getDate() +
      "/" +
      (fecha_pago.getMonth() + 1) +
      "/" +
      fecha_pago.getFullYear();
    let mes: any = fecha_pago.getMonth() + 1;
    mes = mes.toString().length == 1 ? "0" + mes : mes;
    let dia: any = fecha_pago.getDate();
    dia = dia.toString().length == 1 ? "0" + dia : dia;
    //return fecha_pago.getFullYear()+"-"+mes+"-"+dia
    return fecha_pago.getFullYear() + "-" + mes + "-" + fecha_.substr(8, 2);
  };

  editCuota(nroCuota: any) {
    let iconEditCuota: any = document.querySelector(`#edit-${nroCuota}`);
    let btnSaveCuota: any = document.querySelector(`#save-${nroCuota}`);
    let fechaCuota: any = document.querySelector(`#fecha-cuota-${nroCuota}`);
    let montoCuota: any = document.querySelector(`#monto-cuota-${nroCuota}`);
    btnSaveCuota.setAttribute("style", "");
    iconEditCuota.setAttribute("style", "display:none;");
    fechaCuota.removeAttribute("disabled");
    montoCuota.removeAttribute("disabled");
  }

  saveCuota(nroCuota: any) {
    let iconEditCuota: any = document.querySelector(`#edit-${nroCuota}`);
    let btnSaveCuota: any = document.querySelector(`#save-${nroCuota}`);
    let fechaCuota: any = document.querySelector(`#fecha-cuota-${nroCuota}`);
    let montoCuota: any = document.querySelector(`#monto-cuota-${nroCuota}`);
    this.simularData({
      cuota: nroCuota,
      monto_cuota: montoCuota.value,
      fecha: fechaCuota.value,
    });
    btnSaveCuota.setAttribute("style", "display:none;");
    iconEditCuota.setAttribute("style", "");
    fechaCuota.setAttribute("disabled", "disabled");
    montoCuota.setAttribute("disabled", "disabled");
    this.simulacionManual = true;
  }
}
